// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as SMSUserApiModel from "../api-model/SMSUserApiModel.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function execute(json) {
  var res = DeccoUtils$Catalyst.resolveResult(SMSUserApiModel.t_decode(json), "SMSUserEntityMapper.res");
  return List.map((function (reasonData) {
                return {
                        profile: reasonData.profile,
                        name: reasonData.name,
                        primary_mobile_number: reasonData.primary_mobile_number,
                        secondary_mobile_number: reasonData.secondary_mobile_number
                      };
              }), res.customer_partner_details);
}

export {
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
